.root {
  align-items: center;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: center;
  padding: 32px;
}

.iconWrap {
  align-items: center;
  background: var(--color-secondary);
  border-radius: 12px;
  display: flex;
  height: 48px;
  justify-content: center;
  width: 48px;
}

.descriptionWrap {
  max-width: 260px;
  text-align: center;
}
